// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/date/date.js#1 $

/**
* @ngdoc directive
* @name tcApp.directive:tcDate
* @description
* Date picker
*/

angular.module('tc.date', ['tc.dateParser', 'tc.position'])
.constant('tcDateConfig', {
	formatDay: 'dd',
	formatMonth: 'MMMM',
	formatYear: 'yyyy',
	formatDayHeader: 'EEE',
	formatDayTitle: 'MMMM yyyy',
	formatMonthTitle: 'yyyy',
	tcDateMode: 'day',
	minMode: 'day',
	maxMode: 'year',
	showWeeks: true,
	startingDay: 1,
	yearRange: 20,
	minDate: null,
	maxDate: null,
	calendarHasData: null
})
.filter('tcDateTranslated', function($filter, GlobalService) {
	// Uses translations from websys.SYSTEM for day & month strings
	var standardDateFilterFn = $filter('date');
	var globalStrings = GlobalService.getGlobalStrings();
	var monthStrings = globalStrings['XMONTHS'].split(',');
	var dayStrings = globalStrings['XDAYS'].split(',');
	return function(dateToFormat, ngDateFormat) {
		if (ngDateFormat === 'MMMM') {
			return monthStrings[dateToFormat.getMonth()];
		} else if (ngDateFormat === 'MMMM yyyy') {
			return (monthStrings[dateToFormat.getMonth()] + ' ' + standardDateFilterFn(dateToFormat, 'yyyy'));
		} else if (ngDateFormat === 'EEE') {
			return dayStrings[dateToFormat.getDay()];
		}
		return standardDateFilterFn(dateToFormat, ngDateFormat);
	};
})
.controller('tcDateCtrl',
	function($scope, $window, $attrs, $parse, $interpolate, $timeout, $log, $q, tcConstants, dateFilter, 
			tcDateConfig, dateParser, GlobalService, tcDateTranslatedFilter) {
	
	var self = this;
	
	var HOT_KEYS = [
		tcConstants.KEY_CODE.ENTER,
		tcConstants.KEY_CODE.SPACE,
		tcConstants.KEY_CODE.PAGE_UP,
		tcConstants.KEY_CODE.PAGE_DOWN,
		tcConstants.KEY_CODE.END,
		tcConstants.KEY_CODE.HOME,
		tcConstants.KEY_CODE.LEFT_ARROW,
		tcConstants.KEY_CODE.UP_ARROW,
		tcConstants.KEY_CODE.RIGHT_ARROW,
		tcConstants.KEY_CODE.DOWN_ARROW,
		tcConstants.KEY_CODE.F6,
		tcConstants.KEY_CODE.ESCAPE,
		tcConstants.KEY_CODE.TAB
	];
	
	var ngModelCtrl = {$setViewValue: angular.noop}; // nullModelCtrl;

	// Modes chain
	this.modes = ['day', 'month', 'year'];

	// Configuration attributes
	angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
						'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange', 'calendarHasData'], function(key, index) {
		self[key] = angular.isDefined($attrs[key]) ?
			(index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key]))
			: tcDateConfig[key];
	});

	// Watchable date attributes
	angular.forEach(['minDate', 'maxDate'], function(key) {
		if ($attrs[key]) {
			$scope.$parent.$watch($parse($attrs[key]), function(value) {
				self[key] = value ? new Date(value) : null;
				self.refreshView();
			});
		} else {
			self[key] = tcDateConfig[key] ? new Date(tcDateConfig[key]) : null;
		}
	});

	$scope.tcDateMode = $scope.tcDateMode || tcDateConfig.tcDateMode;
	$scope.uniqueId = $attrs.fieldId + '-tcDate';
	this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();
	this.calendar = angular.isDefined($attrs.calendar);
	
	self.configuration = {
		dateSeparator: '/',
		dateFormat: 'DMY'
	};
	if (angular.isDefined(GlobalService.configuration.date)) {
		self.configuration.dateSeparator = GlobalService.configuration.date.separator;
		self.configuration.dateFormat = GlobalService.configuration.date.format;
		self.configuration.dowWeekend = GlobalService.configuration.date.dowWeekend;
		self.startingDay = GlobalService.configuration.date.startingDay;
	}
	var globalStrings = GlobalService.getGlobalStrings();
	self.configuration.globalStrings = {
		'XMONTHSHIJRA': globalStrings.XMONTHSHIJRA.split(',')
	};

	$scope.isActive = function(dateObject) {
		if (self.compare(dateObject.date, self.activeDate) === 0) {
			$scope.activeDateId = dateObject.uid;
			return true;
		}
		return false;
	};

	this.init = function(ngModelCtrl_) {
		ngModelCtrl = ngModelCtrl_;
		if (ngModelCtrl.$modelValue) {
			self.activeDate = dateParser.toDate(ngModelCtrl.$modelValue);
		}
		ngModelCtrl.$render = function() {
			self.render();
		};
	};

	this.render = function() {
		if (ngModelCtrl.$modelValue) {
			var date = dateParser.parse(ngModelCtrl.$modelValue);
			var isValid = angular.isDefined(date);

			if (isValid) {
				this.activeDate = dateParser.toDate(date);
			} else {
				$log.error('tcDate directive: "ng-model" value must be a Date object, a number of milliseconds ' +
					'since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
			}
			ngModelCtrl.$setValidity('date', isValid);
		}
		this.refreshView();
	};

	this.refreshView = function() {
		if (this.element) {
			this._refreshView();

			var date = ngModelCtrl.$modelValue ? dateParser.toDate(ngModelCtrl.$modelValue) : null;
			ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
		}
	};

	this.createDateObject = function(date, ngDateFormat, dateExtended) {
		return {
			date: date,
			label: ((ngDateFormat.indexOf('MMMM') !== -1) ? tcDateTranslatedFilter(date, ngDateFormat)
					: dateFilter(date, ngDateFormat)),
			labelExtended: (angular.isDefined(dateExtended) ? (dateExtended) : ''),
			disabled: this.isDisabled(date),
			current: (this.compare(date, new Date()) === 0),
		};
	};

	this.updateHasData = function(days, month, year) {
		// Only run hasData once per calendar month
		if (self.currentMonthYear == '' + month + year) return;
		self.currentMonthYear = '' + month + year;
		// Don't run if there is no hasData function
		if (!angular.isFunction(this.calendarHasData)) return;
		if (!angular.isFunction(this.calendarHasData())) return;
		var hasData = this.calendarHasData()(month + 1, year);
		// Value should be in comma delimited format: date1,date2,date3,...
		// Date format should be LogicalToHtml.
		// Order does not matter.
		// Different approach depending if this is a promise or string value.
		if (!angular.isFunction(hasData)) {
			self.hasDataArray = hasData.split(',');
		} else {
			$q.when(hasData).then(function(data) {
				self.hasDataArray = data.split(',');
				self.refreshView();
			});
		}
	};

	this.isDisabled = function(date) {
		return (
			(this.minDate && this.compare(date, this.minDate) < 0) ||
			(this.maxDate && this.compare(date, this.maxDate) > 0) ||
			($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.tcDateMode}))
		);
	};

	// Split array into smaller arrays
	this.split = function(arr, size) {
		var arrays = [];
		while (arr.length > 0) {
			arrays.push(arr.splice(0, size));
		}
		return arrays;
	};

	$scope.select = function(date, $event) {
		$event.stopPropagation();
		if ($scope.tcDateMode === self.minMode) {
			var dt = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date(0, 0, 0, 0, 0, 0, 0);
			dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
			ngModelCtrl.$setViewValue(dateParser.prettyDate(dt));
			ngModelCtrl.$commitViewValue();
			ngModelCtrl.$render();
		} else {
			self.activeDate = date;
			$scope.tcDateMode = self.modes[ self.modes.indexOf($scope.tcDateMode) - 1 ];
		}
	};

	$scope.move = function(direction) {
		var year = self.activeDate.getFullYear() + direction * (self.step.years || 0);
		var month = self.activeDate.getMonth() + direction * (self.step.months || 0);
		var day = 1;
		var enteredDate = dateParser.toDate(ngModelCtrl.$modelValue);
		// Re-select the same day when selecting the month of the entered date
		if ((enteredDate)
			&& ((enteredDate.getFullYear() == year) && (enteredDate.getMonth() == month))) {
			day = enteredDate.getDate();
		}
		self.activeDate.setFullYear(year, month, day);
		self.refreshView();
	};

	$scope.toggleMode = function($event, direction) {
		$event.stopPropagation();
		direction = direction || 1;

		if (($scope.tcDateMode === self.maxMode && direction === 1) ||
			($scope.tcDateMode === self.minMode && direction === -1)) {
			return;
		}

		$scope.tcDateMode = self.modes[ self.modes.indexOf($scope.tcDateMode) + direction ];
	};

	var focusElement = function() {
		if (angular.isUndefined($attrs.calendar)) {
			$timeout(function() {
				self.element[0].focus();
			}, 0, false);
		}
	};

	// Listen for focus requests from popup directive
	$scope.$on('tcDate:focus', focusElement);

	$scope.keydown = function($event) {
		// if we are in calendar mode, allow default behavior for TAB key
		if (((HOT_KEYS.indexOf($event.which) == -1) || $event.shiftKey || $event.altKey)
			|| (($attrs.calendar) && ($event.which === tcConstants.KEY_CODE.TAB))) {
			return;
		}

		$event.preventDefault();
		$event.stopPropagation();

		if (($event.which === tcConstants.KEY_CODE.ENTER) || ($event.which === tcConstants.KEY_CODE.SPACE)
			|| ($event.which === tcConstants.KEY_CODE.TAB)) {
			if (self.isDisabled(self.activeDate)) {
				return; // do nothing
			}
			$scope.select(self.activeDate, $event);
			focusElement();
		} else if ($event.ctrlKey && 
			($event.which === tcConstants.KEY_CODE.UP_ARROW || $event.which === tcConstants.KEY_CODE.DOWN_ARROW)) {
			$scope.toggleMode($event, ($event.which === tcConstants.KEY_CODE.UP_ARROW) ? 1 : -1);
			focusElement();
		} else {
			self.handleKeyDown($event);
			self.refreshView();
		}
	};
})

.directive('tcDate', function() {
	return {
		restrict: 'EA',
		replace: true,
		templateUrl: 'template/date/date.html',
		scope: {
			tcDateMode: '=?',
			dateDisabled: '&'
		},
		require: ['tcDate', '?^ngModel'],
		controller: 'tcDateCtrl',
		link: function(scope, element, attrs, ctrls) {
			var tcDateCtrl = ctrls[0];
			var ngModelCtrl = ctrls[1];

			if (ngModelCtrl) {
				tcDateCtrl.init(ngModelCtrl);
			}
		}
	};
})

.directive('tcdaypicker', ['dateFilter', 'tcConstants', 'dateParser','tcDateTranslatedFilter',
	function(dateFilter, tcConstants, dateParser, tcDateTranslatedFilter) {
	return {
		restrict: 'EA',
		replace: true,
		templateUrl: 'template/date/dayPicker.html',
		require: '^tcDate',
		link: function(scope, element, attrs, ctrl) {
			scope.showWeeks = ctrl.showWeeks;
			scope.calendar = ctrl.calendar;
			
			ctrl.step = {months: 1};
			ctrl.element = element;
			ctrl.hasDataArray = [];

			var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			function getDaysInMonth(year, month) {
				return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ?
					29 : DAYS_IN_MONTH[month];
			}

			function getDates(startDate, n) {
				var dates = new Array(n);
				var current = new Date(startDate);
				var i = 0;
				current.setHours(12); // Prevent repeated dates because of timezone bug
				while (i < n) {
					dates[i++] = new Date(current);
					current.setDate(current.getDate() + 1);
				}
				return dates;
			}

			ctrl._refreshView = function() {
				var year = ctrl.activeDate.getFullYear();
				var month = ctrl.activeDate.getMonth();
				var daysInMonth = getDaysInMonth(year, month);
				var firstDayOfMonth = new Date(year, month, 1);
				var difference = ctrl.startingDay - firstDayOfMonth.getDay();
				var numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : -difference;
				var firstDate = new Date(firstDayOfMonth);

				if (numDisplayedFromPreviousMonth > 0) {
					firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
				}

				// Update hasData array for current month and year
				ctrl.updateHasData(days, month, year);

				// 42 is the number of days on a six-week calendar
				var days = getDates(firstDate, 42);
				var monthForDay,dateExtended,dateHijra;
				for (var i = 0; i < 42; i++) {
					if (ctrl.configuration.dateFormat === 'HIJRA') {
						if (i < numDisplayedFromPreviousMonth) {
							monthForDay = month;
						} else if (i >= (numDisplayedFromPreviousMonth + daysInMonth)) {
							monthForDay = (month + 2);
						} else {
							monthForDay = (month + 1);
						}
						dateHijra = dateParser.gregorianToHijra([dateFilter(days[i], 'd'), monthForDay, year]);
						dateExtended = (dateHijra[0] + ctrl.configuration.dateSeparator + dateHijra[1]);
					}
					days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay, dateExtended), {
						secondary: days[i].getMonth() !== month,
						uid: scope.uniqueId + '-' + i
					});
					if (ctrl.hasDataArray.indexOf(dateParser.prettyDate(days[i].date)) != -1) {
						days[i].hasData = true;
					}
				}
				scope.labels = new Array(7);
				scope.weekends = new Array(7);
				for (var j = 0; j < 7; j++) {
					scope.labels[j] = {
						abbr: tcDateTranslatedFilter(days[j].date, ctrl.formatDayHeader),
						full: dateFilter(days[j].date, 'EEEE')
					};
					if (ctrl.configuration.dowWeekend.indexOf((j + ctrl.startingDay) % 7) >= 0) scope.weekends[j] = true;
				}

				scope.title = tcDateTranslatedFilter(ctrl.activeDate, ctrl.formatDayTitle);
				if (ctrl.configuration.dateFormat === 'HIJRA') {
					dateHijra = dateParser.gregorianToHijra([1,	(ctrl.activeDate.getMonth() + 1), ctrl.activeDate.getFullYear()]);
					var monthFrom = parseInt(dateHijra[1] - 1, 10);
					var monthTo = parseInt(dateHijra[1], 10);
					if (monthTo == 12) monthTo = 0;
					scope.titleExtended = (' [' + ctrl.configuration.globalStrings.XMONTHSHIJRA[monthFrom]
									+ ' - ' + ctrl.configuration.globalStrings.XMONTHSHIJRA[monthTo]
									+ ' ' + dateHijra[2] + ']');
				} else if (ctrl.configuration.dateFormat === 'THAI') {
					var titleArray = scope.title.split(' ');
					titleArray[titleArray.length - 1] = (parseInt(titleArray[titleArray.length - 1], 10)
														+ tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT);
					scope.title = titleArray.join(' ');
					scope.title += (' [' + ctrl.activeDate.getFullYear()  + ']');
				}
				scope.rows = ctrl.split(days, 7);

				if (scope.showWeeks) {
					scope.weekNumbers = [];
					var weekNumber = getISO8601WeekNumber(scope.rows[0][0].date);
					var numWeeks = scope.rows.length;
					while (scope.weekNumbers.push(weekNumber++) < numWeeks) {
						//Do nothing
					}
				}
			};

			ctrl.compare = function(date1, date2) {
				var date1Object = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
				var date2Object = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
				return (date1Object - date2Object);
			};

			function getISO8601WeekNumber(date) {
				var checkDate = new Date(date);
				checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
				var time = checkDate.getTime();
				checkDate.setMonth(0); // Compare with Jan 1
				checkDate.setDate(1);
				return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
			}

			ctrl.handleKeyDown = function($event) {
				var date = ctrl.activeDate.getDate();

				if ($event.which === tcConstants.KEY_CODE.LEFT_ARROW) {
					date = date - 1;
				} else if (($event.which === tcConstants.KEY_CODE.F6) || ($event.which === tcConstants.KEY_CODE.ESCAPE)) {
					scope.$emit('tcDate:close');
				} else if ($event.which === tcConstants.KEY_CODE.UP_ARROW) {
					date = date - 7;
				} else if ($event.which === tcConstants.KEY_CODE.RIGHT_ARROW) {
					date = date + 1;
				} else if ($event.which === tcConstants.KEY_CODE.DOWN_ARROW) {
					date = date + 7;
				} else if ($event.which === tcConstants.KEY_CODE.PAGE_UP || $event.which === tcConstants.KEY_CODE.PAGE_DOWN) {
					var month = ctrl.activeDate.getMonth() + ($event.which === tcConstants.KEY_CODE.PAGE_DOWN ? 1 : -1);
					ctrl.activeDate.setMonth(month, 1);
					date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
				} else if ($event.which === tcConstants.KEY_CODE.HOME) {
					date = 1;
				} else if ($event.which === tcConstants.KEY_CODE.END) {
					date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
				}
				ctrl.activeDate.setDate(date);
			};

			ctrl.refreshView();
		}
	};
}])

.directive('tcmonthpicker', ['dateFilter', 'tcConstants', 'dateParser', function(dateFilter, tcConstants, dateParser) {
	return {
		restrict: 'EA',
		replace: true,
		templateUrl: 'template/date/monthPicker.html',
		require: '^tcDate',
		link: function(scope, element, attrs, ctrl) {
			ctrl.step = {years: 1};
			ctrl.element = element;
			scope.calendar = ctrl.calendar;

			ctrl._refreshView = function() {
				var months = new Array(12);
				var year = ctrl.activeDate.getFullYear();
				var day,dateHijra,dateExtended,monthFrom,monthTo;
				for (var i = 0; i < 12; i++) {
					day = 1;
					// Re-select the same day when selecting the month of the entered date
					if (ctrl.activeDate) {
						if ((ctrl.activeDate.getFullYear() == year) && (ctrl.activeDate.getMonth() == i)) {
							day = ctrl.activeDate.getDate();
						}
					}
					if (ctrl.configuration.dateFormat === 'HIJRA') {
						dateHijra = dateParser.gregorianToHijra([1, (i + 1), year]);
						monthFrom = parseInt(dateHijra[1] - 1, 10);
						monthTo = parseInt(dateHijra[1], 10);
						if (monthTo == 12) monthTo = 0;
						dateExtended = (ctrl.configuration.globalStrings.XMONTHSHIJRA[monthFrom]
										+ ' - ' + ctrl.configuration.globalStrings.XMONTHSHIJRA[monthTo]);
					}
					months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, day),  ctrl.formatMonth, dateExtended), {
						uid: scope.uniqueId + '-' + i
					});
				}

				scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
				if (ctrl.configuration.dateFormat === 'HIJRA') {
					dateHijra = dateParser.gregorianToHijra([ctrl.activeDate.getDate(),
									(ctrl.activeDate.getMonth() + 1), ctrl.activeDate.getFullYear()]);
					scope.title += (' [' + dateHijra[2] + ']');
				} else if (ctrl.configuration.dateFormat === 'THAI') {
					scope.title = ((ctrl.activeDate.getFullYear() + tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT)
									+ ' [' + ctrl.activeDate.getFullYear() + ']');
				}
				scope.rows = ctrl.split(months, 3);
			};

			ctrl.compare = function(date1, date2) {
				return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
			};

			ctrl.handleKeyDown = function($event) {
				var date = ctrl.activeDate.getMonth();

				if ($event.which === tcConstants.KEY_CODE.LEFT_ARROW) {
					date = date - 1;
				} else if (($event.which === tcConstants.KEY_CODE.F6) || ($event.which === tcConstants.KEY_CODE.ESCAPE)) {
					scope.$emit('tcDate:close');
				} else if ($event.which === tcConstants.KEY_CODE.UP_ARROW) {
					date = date - 3;
				} else if ($event.which === tcConstants.KEY_CODE.RIGHT_ARROW) {
					date = date + 1;
				} else if ($event.which === tcConstants.KEY_CODE.DOWN_ARROW) {
					date = date + 3;
				} else if ($event.which === tcConstants.KEY_CODE.PAGE_UP || $event.which === tcConstants.KEY_CODE.PAGE_DOWN) {
					var year = ctrl.activeDate.getFullYear() + ($event.which === tcConstants.KEY_CODE.PAGE_UP ? -1 : 1);
					ctrl.activeDate.setFullYear(year);
				} else if ($event.which === tcConstants.KEY_CODE.HOME) {
					date = 0;
				} else if ($event.which === tcConstants.KEY_CODE.END) {
					date = 11;
				}
				ctrl.activeDate.setMonth(date);
			};

			ctrl.refreshView();
		}
	};
}])

.directive('tcyearpicker', function(tcConstants, dateParser) {
	return {
		restrict: 'EA',
		replace: true,
		templateUrl: 'template/date/yearPicker.html',
		require: '^tcDate',
		link: function(scope, element, attrs, ctrl) {
			var range = ctrl.yearRange;
			scope.calendar = ctrl.calendar;
			
			ctrl.step = {years: range};
			ctrl.element = element;

			function getStartingYear(year) {
				return parseInt((year - 1) / range, 10) * range + 1;
			}

			ctrl._refreshView = function() {
				var years = new Array(range);
				var year,yearExtended;
				
				for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
					year = new Date(start + i, 0, 1);
					if (ctrl.configuration.dateFormat === 'HIJRA') {
						yearExtended = dateParser.gregorianToHijra([1, 1, start + i])[2];
					} else if (ctrl.configuration.dateFormat === 'THAI') {
						yearExtended = (start + i);
					}
					years[i] = angular.extend(ctrl.createDateObject(year, ctrl.formatYear, yearExtended), {
						uid: scope.uniqueId + '-' + i
					});
					if (ctrl.configuration.dateFormat === 'THAI') {
						years[i].label = (parseInt(years[i].label, 10) + tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT);
					}
				}

				scope.title = [years[0].label, years[range - 1].label].join(' - ');
				if (['THAI','HIJRA'].indexOf(ctrl.configuration.dateFormat) !== -1) {
					scope.title += ('\n[' + [years[0].labelExtended, years[range - 1].labelExtended].join(' - ') + ']');
				}
				scope.rows = ctrl.split(years, 5);
			};

			ctrl.compare = function(date1, date2) {
				return date1.getFullYear() - date2.getFullYear();
			};

			ctrl.handleKeyDown = function($event) {
				var date = ctrl.activeDate.getFullYear();

				if ($event.which === tcConstants.KEY_CODE.LEFT_ARROW) {
					date = date - 1;
				} else if (($event.which === tcConstants.KEY_CODE.F6) || ($event.which === tcConstants.KEY_CODE.ESCAPE)) {
					scope.$emit('tcDate:close');
				} else if ($event.which === tcConstants.KEY_CODE.UP_ARROW) {
					date = date - 5;
				} else if ($event.which === tcConstants.KEY_CODE.RIGHT_ARROW) {
					date = date + 1;
				} else if ($event.which === tcConstants.KEY_CODE.DOWN_ARROW) {
					date = date + 5;
				} else if ($event.which === tcConstants.KEY_CODE.PAGE_UP || $event.which === tcConstants.KEY_CODE.PAGE_DOWN) {
					date += ($event.which === tcConstants.KEY_CODE.PAGE_UP ? -1 : 1) * ctrl.step.years;
				} else if ($event.which === tcConstants.KEY_CODE.HOME) {
					date = getStartingYear(ctrl.activeDate.getFullYear());
				} else if ($event.which === tcConstants.KEY_CODE.END) {
					date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
				}
				ctrl.activeDate.setFullYear(date);
			};

			ctrl.refreshView();
		}
	};
})

.constant('tcDatePopupConfig', {
	tcDatePopup: 'dd/MM/yyyy',
	currentText: 'Today',
	clearText: 'Clear',
	closeText: 'Done',
	closeOnDateSelection: true,
	showButtonBar: true
})

.directive('tcDatePopup', function($compile, $parse, $position, $timeout, $window, $mdMedia,
			dateFilter, dateParser, tcDateConfig, tcDatePopupConfig, GlobalService, tcConstants) {
	return {
		restrict: 'EA',
		require: 'ngModel',
		scope: {
			isOpen: '=?',
			currentText: '@',
			clearText: '@',
			closeText: '@',
			dateDisabled: '&',
			calendarHasData: '&'
		},
		link: function(scope, element, attrs, ngModel) {
			var closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ?
				scope.$parent.$eval(attrs.closeOnDateSelection) : tcDatePopupConfig.closeOnDateSelection;
			var isTouchDevice = GlobalService.isTouchDevice();
			
			if (attrs.customlookup) {
				var configuration = {
					lookupKeyCode: tcConstants.KEY_CODE.F6,
				};
			
				// Get lookup configuration from Global Service
				if (angular.isDefined(GlobalService.configuration.lookup)) {
					configuration = GlobalService.configuration.lookup;
				}
			}
			
			if (angular.isDefined(attrs.calendar)) {
				scope.isOpen = true;
				scope.calendar = true;
				closeOnDateSelection = false;	
			}

			scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ?
				scope.$parent.$eval(attrs.showButtonBar) : tcDatePopupConfig.showButtonBar;

			scope.toggleLookup = function() {
				scope.isOpen = !scope.isOpen;
			};
			
			scope.clearField = function($event) {
				$event.preventDefault();
				$event.stopPropagation();
				
				scope.dateSelection('');
				element[0].focus();	
			};
			
			scope.isEmpty = function() {
				var value = element.val();
				return (value === '');
			};

			var disabled = false;
			var readOnly = false;
			attrs.$observe('disabled', function(value) {
				disabled = value;
			});
			attrs.$observe('readonly', function(value) {
				readOnly = value;
			});
			scope.lookupEnabled = function() {
				return ((!disabled) && (!readOnly) && (!attrs.calendar) && (!attrs.customlookup));
			};

			scope.getText = function(key) {
				return scope[key + 'Text'] || tcDatePopupConfig[key + 'Text'];
			};

			element.addClass('tcDate');

			attrs.$observe('tcDatePopup', function() {
				ngModel.$render();
			});
			
			var scrollDatePopupIntoView = function() {
				var datePopupElement = (popupEl[0] && popupEl[0].querySelector('.calendar'));
				if (!datePopupElement || !element[0]) return;

				GlobalService.scrollElementIntoView(element[0], datePopupElement);
			};

			// popup element used to display calendar
			var popupEl = angular.element('<div tc-date-popup-wrap tabIndex="-1"><div tc-date></div></div>');
			popupEl.attr({
				'ng-model': 'date',
				'ng-change': 'dateSelection()',
				'field-Id': attrs.id,
				'toggle-Lookup': 'toggleLookup()',
				'is-Open': 'isOpen',
				'lookup-Enabled': 'lookupEnabled()',
				'close-datepicker': 'closeDatepicker()',
				'calendar': attrs.calendar,
				'has-focus': 'hasFocus',
				'clear-Field': 'clearField($event)',
				'is-Empty': 'isEmpty()',
				'is-Touch-Device': isTouchDevice
			});
			
			function cameltoDash(string) {
				return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
			}

			// tcDate element
			var tcDateEl = angular.element(popupEl.children()[0]);
			if (attrs.tcDateOptions) {
				angular.forEach(scope.$parent.$eval(attrs.tcDateOptions), function(value, option) {
					tcDateEl.attr(cameltoDash(option), value);
				});
			}
			tcDateEl.attr('field-Id', attrs.id);
			tcDateEl.attr('calendar-has-data', 'calendarHasData');
			if (attrs.calendar) {
				tcDateEl.attr('calendar', true);	
			}

			scope.watchData = {};
			angular.forEach(['minDate', 'maxDate', 'tcDateMode'], function(key) {
				if (attrs[key]) {
					var getAttribute = $parse(attrs[key]);
					scope.$parent.$watch(getAttribute, function(value) {
						scope.watchData[key] = value;
					});
					tcDateEl.attr(cameltoDash(key), 'watchData.' + key);

					// Propagate changes from tcDate to outside
					if (key === 'tcDateMode') {
						var setAttribute = getAttribute.assign;
						scope.$watch('watchData.' + key, function(value, oldvalue) {
							if (value !== oldvalue) {
								setAttribute(scope.$parent, value);
							}
						});
					}
				}
			});
			if (attrs.dateDisabled) {
				tcDateEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
			}

			function parseDate(viewValue) {
				if (!viewValue) {
					ngModel.$setValidity('date', true);
					return '';
				} else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
					ngModel.$setValidity('date', true);
					return viewValue;
				} else if (angular.isString(viewValue)) {
					var date = dateParser.parse(viewValue, tcDateConfig);
					if (angular.isUndefined(date) || (viewValue != '' && date == '')) {
						ngModel.$setValidity('date', false);
						$timeout(function focusInputElement() {
							element[0].focus();
						});
						return viewValue;
					} else {
						ngModel.$setValidity('date', true);
						// if parsed date different from user entered date, alert screen reader users
						if (date !== viewValue) {
							var alert = GlobalService.getGlobalStrings()['XDATECONVERT'] + ' ' + date;
							GlobalService.announce(alert, 'alert');
						}
						return date;
					}
				} else {
					ngModel.$setValidity('date', false);
					return '';
				}
			}
			ngModel.$parsers.unshift(parseDate);

			// Inner change
			scope.dateSelection = function(dt) {
				if (angular.isDefined(dt)) {
					scope.date = dt;
				}
				ngModel.$setDirty();
				ngModel.$setViewValue(scope.date);
				ngModel.$commitViewValue();
				ngModel.$render();

				if (closeOnDateSelection) {
					scope.isOpen = false;
					if (!isTouchDevice) element[0].focus();
				}
			};

			element.bind('input change keyup blur', function($event) {
				if (($event) && ($event.type === 'keyup') && ($event.which === tcConstants.KEY_CODE.TAB)) {
					// Don't run when tabbing into a date field
					return;
				}
				scope.$applyAsync(function() {
					scope.date = ngModel.$modelValue;
				});
			});

			element.bind('blur', function() {
				if (ngModel.$modelValue !== ngModel.$viewValue) {
					element.val(ngModel.$modelValue);
				}
				scope.hasFocus = false;
			});
			
			element.bind('focus', function() {
				scope.hasFocus = true;
			});

			// Outter change
			ngModel.$render = function() {
				var date = ngModel.$viewValue ? parseDate(ngModel.$viewValue) : '';
				element.val(date);
				scope.date = parseDate(ngModel.$modelValue);
			};
			
			var closeDatepicker = function() {
				if (!attrs.calendar) {
					scope.isOpen = false;
				}
			};
			if (angular.isUndefined(attrs.calendar)) scope.closeDatepicker = closeDatepicker;
			
			var keydown = function($event) {
				scope.keydown($event);
			};
			element.bind('keydown', keydown);

			scope.keydown = function($event) {
				if (scope.lookupEnabled()) {
					if (!attrs.customLookup) {
						if (($event.which === tcConstants.KEY_CODE.ESCAPE) || 
							(($event.which === tcConstants.KEY_CODE.F6) && (scope.isOpen))) {
							$event.preventDefault();
							$event.stopPropagation();
							scope.close();
						} else if ((($event.which === tcConstants.KEY_CODE.DOWN_ARROW) || 
							($event.which === tcConstants.KEY_CODE.F6)) && !scope.isOpen) {
							$event.preventDefault();
							$event.stopPropagation();
							scope.isOpen = true;
						} else if (($event.which === tcConstants.KEY_CODE.ENTER) && 
							(element[0].value !== ngModel.$modelValue)) {
							$event.preventDefault();
							$event.stopPropagation();
							element[0].blur();
							scope.close();
						}
					} else {
						// catch any keystroke that opens the custom lookup and render 
						if (($event.which === tcConstants.KEY_CODE.DOWN_ARROW) ||
							($event.which === tcConstants.KEY_CODE.DOWN_ARROW) ||
							($event.which === configuration.lookupKeyCode)) {
							if (ngModel.$modelValue !== ngModel.$viewValue) {
								ngModel.$render();
							}
						}	
					}
				}
			};
			
			if (angular.isUndefined(attrs.calendar)) {
				scope.$watch('isOpen', function(value) {
					if (value) {
						$timeout(function() {
							scope.$broadcast('tcDate:focus');
						});
						scope.position = $position.position(element);
						scope.position.top = scope.position.top + element.prop('offsetHeight');

						var fieldPosition = $position.offset(element);
						var calendarRight = fieldPosition.left
											+ (GlobalService.configuration.date.format === 'HIJRA' ? 470 : 315);
						var calendarBottom = fieldPosition.top + 330;
					
						var containerPosition = {left: 0, top: 0, width: $window.innerWidth, height: $window.innerHeight};
						var dialogs = angular.element($window.document).find('md-dialog');
						if (dialogs.length) {
							var form = dialogs.find('form');
							if (form) containerPosition = $position.offset(form);
						}
						if ((containerPosition.left + containerPosition.width) < calendarRight) {
							if ($mdMedia('xs')) {
								scope.position.left = (-fieldPosition.left + 10);
							} else {
								scope.position.left = (-(calendarRight - containerPosition.width) - 70);
							}
						}
						if ((dialogs.length === 0) && ((containerPosition.top + containerPosition.height) < calendarBottom)) {
							$timeout(scrollDatePopupIntoView);
						}
					}
				
				});
			}

			scope.select = function(date) {
				if (date === 'today') {
					var today = new Date();
					if (angular.isDate(ngModel.$modelValue)) {
						date = new Date(ngModel.$modelValue);
						date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
					} else {
						date = new Date(today.setHours(0, 0, 0, 0));
					}
				}
				scope.dateSelection(date);
			};

			scope.close = function() {
				if (!attrs.calendar) {
					scope.isOpen = false;
					element[0].focus();
				}
			};

			var $popup = $compile(popupEl)(scope);
			// Prevent jQuery cache memory leak (template is now redundant after linking)
			popupEl.remove();
			element.after($popup);
			
			if (angular.isUndefined(attrs.calendar)) {
				// Emit an event to allow behavior in container directives (e.g. overlay)
				scope.$emit('tcDatePopup:Init');
			}

			scope.$on('tcDate:close', scope.close);

			scope.$on('$destroy', function() {
				$popup.remove();
				element.unbind('keydown', keydown);
			});
		}
	};
})

.directive('tcDatePopupWrap', function(GlobalService,tcConstants) {
	return {
		restrict: 'EA',
		scope: {
			fieldId: '@',
			toggleLookup: '&',
			closeDatepicker: '&',
			isOpen: '=?',
			lookupEnabled: '&',
			calendar: '=?',
			calendarHasData: '&',
			hasFocus: '=?',
			clearField: '&',
			isEmpty: '&',
			isTouchDevice: '=?'
		},
		replace: true,
		transclude: true,
		templateUrl: 'template/date/datePopup.html',
		link: function(scope, element, attrs) {
			var isHijra = false;
			if (angular.isDefined(GlobalService.configuration.date)) {
				isHijra = (GlobalService.configuration.date.format === 'HIJRA');
			}
			scope.fieldId = attrs.fieldId;
			scope.isRTL = false;
			if (angular.isDefined(GlobalService.logonData)) {
				scope.isRTL = (GlobalService.logonData.langDirection === tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT);
			}

			scope.getDatePopupClass = function() {
				var datePopupClass = 'calendar';
				
				if (isHijra) {
					datePopupClass += ' calendarHijra';
				}
				if ((angular.isDefined(attrs.calendar)) && (attrs.calendar == 'true')) {
					datePopupClass += ' no-popup';
				}
				return datePopupClass;
			};
			if (scope.isTouchDevice); {
				scope.showQuickDelete = function() {
					return (scope.hasFocus && !scope.isEmpty() && scope.lookupEnabled());	
				};
			}
		}
	};
});
